import { render, staticRenderFns } from "./Point.vue?vue&type=template&id=57d50322&scoped=true"
import script from "./Point.vue?vue&type=script&lang=js"
export * from "./Point.vue?vue&type=script&lang=js"
import style0 from "./Point.vue?vue&type=style&index=0&id=57d50322&prod&lang=scss&scoped=true"
import style1 from "./Point.vue?vue&type=style&index=1&id=57d50322&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d50322",
  null
  
)

export default component.exports